import React from 'react';

import { AdminFormTab } from 'Components/Admin/Form';

import MobileAppSVG from 'Components/Admin/assets/MibileAppSVG';
import ShareLinkSVG from 'Components/Admin/assets/ShareLinkSVG';

const MobileApps = () => {
  const formItems = [
    {
      title: 'Mobile apps settings',
      subTitle: 'Configure the use of files for mobile devices in your project.',
      items: [
        {
          type: 'switches',
          name: 'apps',
          switches: [
            {
              name: 'isMobile',
              getIcon: (isActive) => <MobileAppSVG isActive={isActive} />,
              label: 'Mobile builds',
              subLabel: 'Project uses files for mobile phones.',
            }, {
              name: 'isShareBuild',
              getIcon: (isActive) => <ShareLinkSVG isActive={isActive} />,
              label: 'Shareable links',
              subLabel: 'The project can be viewed at the link.',
            },
          ],
        },
      ],
    },
  ];

  return (
    <div className="mobile-apps-form" data-testid="projects-mobile-apps-form">
      <AdminFormTab
        formItems={formItems}
        isBlocks
      />
    </div>
  );
};

export default MobileApps;
